/** Parse `value` for MUI (`Date | null`). Supports `HH:mm` strings and `Date`. */
export function toPickerTime(value: string | Date | null | undefined): Date | null {
  if (value == null || value === '') return null;
  if (value instanceof Date) {
    return Number.isNaN(value.getTime()) ? null : value;
  }

  const time = /^(\d{1,2}):(\d{2})$/.exec(value);
  if (time) {
    const date = new Date();
    date.setHours(Number(time[1]), Number(time[2]), 0, 0);
    return date;
  }

  const date = new Date(value);
  return Number.isNaN(date.getTime()) ? null : date;
}

/** Format as `HH:mm` for string-mode consumers. */
export function toPickerTimeString(date: Date | null): string | null {
  if (!date || Number.isNaN(date.getTime())) return null;
  const hours = String(date.getHours()).padStart(2, '0');
  const minutes = String(date.getMinutes()).padStart(2, '0');
  return `${hours}:${minutes}`;
}

export function formatTimePickerChange(value: string, date: Date | null): string | null;
export function formatTimePickerChange(value: Date | null, date: Date | null): Date | null;
export function formatTimePickerChange(
  value: string | Date | null,
  date: Date | null
): string | Date | null {
  return typeof value === 'string' ? toPickerTimeString(date) : date;
}
